import {React,useEffect,useReducer,useState} from 'react'
import {Homeproduction} from './Fetcher'
import Singlegadget from './Singlegadget'
import Loader from '../component/Loader'




const initaistate ={
 
  loading : true,
  data : [],
  error : '',

}


const reducer = (state,action)=>{
switch(action.type){
  case 'sucess' :
    return{...state,
      loading: false ,
      data: action.payload,
      error: ''
    }
case 'error' :
  return{...state,
    loading: false ,
    data: [],
    error: action.errormessage
  }
}
}


const Displayphone = () => {


    const [ productdata , dispatch] = useReducer(reducer,initaistate)
    useEffect(()=>{
      Homeproduction({dispatch:dispatch})
    },[])


    const rerenderproduct=()=>{
        return  productdata.data.map(data=>(
         <Singlegadget key={data.id} data={data}/>
        
        ))
      }
  return (
    <>
    <div id='display-phone-wrapper'>
        <div id='display-phone'>
<h5 style={{borderBottom:'3px solid #B3DDEF'}}>Grab the best deal on <span style={{color:'#B3DDEF',}}>Smartphones</span></h5>
<h5 style={{borderBottom:'3px solid black'}}>See All</h5>
 </div>
   <div id='single-wrapper'>
  {productdata.loading?<Loader/>:rerenderproduct()}
  {productdata.error?productdata.error :''}
      </div>
    </div>
    </>
  )
}


export default Displayphone